import { Skeleton, Stack } from '@mui/material';

import SaraCircleMark from '../SaraCircleMark';

const AssistantLoadingSkeleton = () => (
    <Stack
        alignItems="flex-start"
        data-testid="copy-generator-message-loading"
        direction="column"
        role="status"
        aria-label="Sara is thinking"
        spacing={0.5}
        sx={{ maxWidth: '78%' }}
    >
        <SaraCircleMark size={24} variant="sara" />
        <Stack spacing={0.75} sx={{ width: '100%' }}>
            <Skeleton variant="text" width="90%" height={24} />
            <Skeleton variant="text" width="70%" height={24} />
            <Skeleton variant="text" width="40%" height={24} />
        </Stack>
    </Stack>
);

export default AssistantLoadingSkeleton;
